<template>
  <carousel
    ref="carousel"
    :per-page="perPage"
    :touch-drag="false"
    :mouse-drag="false"
    navigation-enabled
    navigation-next-label="<i aria-hidden=&quot;true&quot; id=&quot;carousel-next&quot; class=&quot;material-icons&quot; style=&quot;position: absolute; bottom:130%; color: #212121; right:100%; z-index:5&quot;>arrow_forward_ios</i>"
    navigation-prev-label="<i aria-hidden=&quot;true&quot; id=&quot;carousel-prev&quot;  class=&quot;material-icons reverse&quot; style=&quot;position: absolute;width:24px; bottom:130%; color:#212121; left:100%;&quot;>arrow_forward_ios</i>"
  >
    <slide
      v-for="(item, i) in refToReload"
      :key="i"
      :class="{
        'half-width': perPage == 2,
        selected: typeof item == 'object' && item.selected,
      }"
      @slideclick="slideClick(item)"
    >
      <product-card
        v-if="carousel.type === 'products' && carousel.values.length"
        :show-index="carousel?.showIndex || false"
        :index="i"
        :product="item"
        :like-dislike="likeDislike"
        :data-test-end-to-end-style-profile="
          $store.state.user.style_profile_key
            ? $store.state.user.style_profile_key
            : ''
        "
      ></product-card>

      <div
        v-else
        class="cleed-w-100"
        :data-test-end-to-end-style-profile="
          $store.state.user.style_profile_key
            ? $store.state.user.style_profile_key
            : ''
        "
      >
        <img
          v-if="attachment"
          :src="item.location"
          class="cleed-w-100"
          @click="openImage(item.location)"
        />
        <img
          v-else
          :src="item.src"
          class="cleed-w-100"
        />
        <p v-if="item.name">
          {{ $t(item.name) }}
        </p>
      </div>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import ProductCard from "./ProductCard";
import { customLogger } from "@/utils";

export default {
  name: "MyCarousel",
  components: {
    Carousel,
    Slide,
    ProductCard,
  },
  props: {
    attachment:  {
      type: Boolean,
      default: () => false,
    },
    "like-dislike": {
      type: Boolean,
      default: () => true,
    },
    carousel: {},
  },
  data() {
    return {
      refToReload: [],
      perPage: 2,
    };
  },
  watch: {
    carousel(newVal, oldVal) {
      this.refToReload = newVal.values;
      this.refToReload.forEach((item, i) => {
        this.$set(item, "selected", false);
      });
      this.$refs.carousel.goToPage(0);
    },
  },
  created() {
    // customLogger("my-carousel mounted", this.carousel);
    this.refToReload = this.carousel.values;
    this.refToReload.forEach((item, i) => {
      this.$set(item, "selected", false);
    });

    this.perPage = this.carousel.perPage || this.perPage;
  },
  methods: {
    openImage(src){
      window.open(src);
    },
    slideClick(item) {
      if (this.carousel.mode == "multiple") {
        item.selected = !item.selected;
        // customLogger('item', item)

        if (!this.$store.state.user.data.tmp_content)
          this.$store.commit("UPDATE_DATA", { tmp_content: [] });
        if (this.$store.state.user.data.tmp_content.indexOf(item.name) !== -1) {
          this.$store.state.user.data.tmp_content =
            this.$store.state.user.data.tmp_content.filter(
              (val) => val != item.name
            );
        } else {
          this.$store.state.user.data.tmp_content.push(item.name);
        }
      } else {
        if (
          this.$store.state.user.style_profile &&
          this.carousel.type == "image"
        )
          this.$eb.emit("StyleImageClick", item);
        else if (this.carousel.type == "image")
          this.$eb.emit("BoxImageClick", item);
      }
    },
  },
};
</script>
